/**
 * ThemeToggle - the sun / moon switch in the navbar.
 * public/rf-theme.js owns the theme (saved choice, else dark) and
 * sets data-theme on <html>; CSS shows the matching icon.
 */

import React from 'react';

const ThemeToggle = () => (
  <button
    type="button"
    className="rf-btn rf-btn-ghost rf-btn-sm rf-theme-btn"
    onClick={() => window.rfTheme && window.rfTheme.toggle()}
    aria-label="Switch light or dark mode"
    title="Light or dark mode"
  >
    <svg className="rf-theme-sun" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
    <svg className="rf-theme-moon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
    </svg>
  </button>
);

export default ThemeToggle;
